module.exports = __webpack_public_path__ + "media/images/header-small.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/header-small.jpg
// module id = 68
// module chunks = 0